import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const H1 = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.77164 2.9125C3.77164 2.47758 3.41907 2.125 2.98414 2.125C2.54922 2.125 2.19664 2.47758 2.19664 2.9125V17.0875C2.19664 17.5224 2.54922 17.875 2.98414 17.875C3.41907 17.875 3.77164 17.5224 3.77164 17.0875V10.7875L9.9684 10.7875V17.0875C9.9684 17.5224 10.321 17.875 10.7559 17.875C11.1908 17.875 11.5434 17.5224 11.5434 17.0875V2.9125C11.5434 2.47758 11.1908 2.125 10.7559 2.125C10.321 2.125 9.9684 2.47758 9.9684 2.9125V9.2125L3.77164 9.2125V2.9125ZM17.8034 8.21034C17.8034 7.61726 17.3226 7.13647 16.7295 7.13647H16.5823C16.3483 7.13647 16.1192 7.20372 15.9223 7.33021L14.3322 8.35179C14.0917 8.50624 13.9464 8.77237 13.9464 9.05811C13.9464 9.72123 14.6791 10.1226 15.2379 9.76559L16.0897 9.22145H16.1433V17.0451C16.1433 17.5035 16.515 17.8751 16.9734 17.8751C17.4318 17.8751 17.8034 17.5035 17.8034 17.0451V8.21034Z"
        fill={color}
      />
    </svg>
  )
})

export default H1
